import React, { useEffect, useRef, useState } from 'react';
import { View, Text, Platform, Keyboard } from 'react-native';
import EnterEmailHeader from './component/Header/Header';
import InputText from '@sharedComponents/TextInput/TextInput';
import Button from '@sharedComponents/Button/Button';
import classes from '../../styles/globalClasses';
import gs from '../../styles/globalStyles';
import BottomSheetContainer from '@sharedComponents/Bottomsheet/Bottomsheet';
import { CheckCircle } from '@sharedComponents/Icons';
import VerifyEmailOTP from './component/VerifyEmailOTP/VerifyEmailOTP';
import axios from 'axios';
import { endpoints } from '../../api/apis';
import { showErrorSheet } from '../../store/slices/errorSlice';
import { useAppDispatch , useAppSelector } from '../../store/hooks';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '../../navigationApp/types';
import fetchUserDetails from '../../helper/fetchUserInfo';
import ROUTE from '../../navigationApp/routes';
import Typography from '@sharedComponents/typography/Typography';
import { ColorTokens, TextAlignTokens, TypographyTypeDLS } from '@voltmoney/schema';
import { Theme, ThemedView } from '../../theme';
import ScreenWrapper from '@hoc/ScreenWrapper';
import {trackEvent} from '../../utils/amplitude'
import KeyboardDismissView from '@app/hoc/KeyboardDismissView';
import SystemError from '../../../assets/Icons/SystemErrorIcon';
import {X } from '@sharedComponents/Icons'
import { ThemedText, ThemedTouchableOpacity } from '@app/theme/Components';
import { useDarkMode } from '@app/utils';
import { getNextRoute } from '@app/navigationApp/navigationUtil';
import { getEnabledRTA } from '../KYCStepper/services/service';
import useIsMobileBrowser from '@app/hooks/useIsMobileBrowser';
import { updateUserDetailEmail } from '@app/store/slices/authSlice';
import { useTheme } from '@shopify/restyle';


const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'ENTER_EMAIL'>;

const EnterEmail = ({ navigation  ,route }: ScreenProps) => {
  const userDetails = useAppSelector(state => state.auth.userDetails);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
  const ref = useRef(null);
  const dispatch = useAppDispatch();
  const {isPLJ} = useAppSelector(state => state.platformParams)
  const isMobileBrowser = useIsMobileBrowser()


  const [showResendError, setShowResendError] = useState({isVisible : false , message : ''});
  const isDarkMode = useDarkMode()
  const showHome = useAppSelector(state => state.platformParams.showHome);

  const {colors} = useTheme<Theme>()



  const fetchUserDetails = () => {
    const url = endpoints.userProfile + userDetails?.linkedApplications[0]?.accountId;
    axios
      .get(url)
      .then(res => {
        // prefill email if found from user details
        if (res?.data?.emailId) {
          setEmail(res?.data?.emailId)
          setIsEmailValid(true);
        }
      })
      .catch(err => {
        // else just silently fail and log the error
        console.log('err', err);
      });
  };

  useEffect(() => {
    if(Platform.OS === 'web') {
      fetchUserDetails()
    }
  },[])


  useEffect(() => {
    if (ref.current) {
      setTimeout(() => {
        // Focus the input after the component mounts
      ref?.current?.focus();
      } , 400)
    }
  }, []);

  const onEmailUpdateSuccess = async () => {
    closeBottomSheet();

    const enabledRTA = await getEnabledRTA({
      applicationId: userDetails?.linkedApplications[0]?.applicationId
    });
    dispatch(updateUserDetailEmail({emailId: email}));
    const nextRoute = getNextRoute(
      userDetails?.linkedApplications[0].currentStepId, 
      userDetails?.linkedApplications[0].applicationState, 
      userDetails?.linkedApplications[0].stepStatusMap,
      enabledRTA?.enabledRtaFlow
    )

    //We are navigating it seperately to avoid the screen auto switch view
    if(Platform.OS === 'android' || Platform.OS === 'ios') {
      navigation.reset({
        routes: [{name: ROUTE.HOME}, { name: nextRoute }],
      });
      return;
    }
    setTimeout(() => {
      // TODO : add logic for navigation based of userdetail 
      fetchUserDetails();
      if(showHome) {
          navigation.reset({
            routes: [{ name: ROUTE.HOME }, { name: nextRoute }],
          });
      } else {
        navigation.reset({
          routes: [{ name: nextRoute }],
        });
      }
    }, 100);
  };
  const closeBottomSheet = () => {
    trackEvent('ENTER_EMAIL_OTP_SHEET_CLOSED') ,{screen : route?.name}
    setIsBottomSheetVisible(false);
    if(showResendError.isVisible) {
      setTimeout(() => {
        setShowResendError({isVisible : false , message : ''})
        }, 400);
    }
  };

  const gotoCheckEligibility = () => {
    navigation.navigate('CheckEligibility');
  };

  const onInput = (text: string) => {
    const updateText = text.replace(/\s/g, '');
    setEmail(updateText);
    if (!emailRegex.test(updateText)) {
      setIsEmailValid(false);
      setError('Enter a valid email address');
    } else {
      setIsEmailValid(true);
      setError('');
    }
  };


  const showErrorSheetForResend = (err :string) => {
    setShowResendError({isVisible : true , message : err})
  }

  const onContinue = () => {
    setButtonLoader(true);
    ref?.current?.blur()
    const payload = {
      borrowerAccountId: userDetails?.linkedBorrowerAccounts[0]?.accountId,
      emailId: email,
    };
    axios
      .post(endpoints.requestEmailOTP, payload)
      .then(res => {
        setIsBottomSheetVisible(true);
        trackEvent('ENTER_EMAIL_OTP_SHEET_LOADED') ,{screen : route?.name}
      })
      .catch(err => {
        console.log('Enter email err', err);
        dispatch(
          showErrorSheet({
            isErrorSheetVisible : true,
            errorMessage: err?.data?.message,
            closeOnBackdropPress: true,
            errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
            routeName: route?.name
          }),
        );
        console.log('err', err);
      })
      .finally(() => {
        setButtonLoader(false);
      });
  };

  return (
    <ScreenWrapper screenName={route?.name} additionalProperties={{newArchRoute : true}}>
      <KeyboardDismissView>
       <ThemedView flex={1}>
      <EnterEmailHeader pageName={route?.name} navigation={navigation} />
      <ThemedView
       flex={1}
       bg='bg-surface-primary'
       padding='lg'
       >
        <ThemedText color='text-primary' variant='h3s'>{isPLJ ?`Enter client’s email` :`Enter your email`}</ThemedText>
        <ThemedText mt='xs' mb='md' color='text-secondary' variant='b3r'>{isPLJ ? "Client will receive notifications on this email." : "We’ll use this to send important updates"}</ThemedText>
        <InputText
          ref={ref}
          keyboardType="email-address"
          label={isPLJ ? "Client's email" : "Email ID"}
          showLabel={true}
          showAnimation
          value={email}
          onChangeText={onInput}
          isDarkMode={Boolean(isDarkMode)}
          showErrorMessage={true}
          hasError={error}
          showRightAccessory={true}
          autoFocus={false}
          rightAccessory={() => {
            return (
              <View style={[gs.flexRow, gs.alignItemsCenter]}>
                {isEmailValid && (
                  <CheckCircle
                    size={24}
                    weight="fill"
                    fill={colors['icon-success']}
                  />
                )}
              </View>
            );
          }}
        />
        <Button
          eventName={'ENTER_EMAIL_CONTIUE'}
          label={'Continue'}
          size="MD"
          handlePress={onContinue}
          type={'SOLID'}
          disabled={!isEmailValid}
          buttonLoader={buttonLoader}
        />
      </ThemedView>
      <BottomSheetContainer
        isVisible={isBottomSheetVisible}
        close={closeBottomSheet}
        closeOnBackdropPress={ showResendError.isVisible ? true :false}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}
        showCloseIcon={Platform.OS !== 'web'}
        containsTextInput
        containerStyle={{ backgroundColor: '#fefefe',
          maxHeight: '80%',
          // minHeight:  isMobileBrowser ? 340 : undefined, 
         }}
        dragComponent={
          <View
            style={{
              width: 200,
              backgroundColor: 'grey',
              borderRadius: 20,
              height: 4,
              marginVertical: 10,
            }}
          />
        }>
            {showResendError.isVisible ? (
               <View
               style={[
                 gs.alignItemsCenter,
                 gs.justifyCenter,
                 gs.setPadding(16),
               ]}>
               <View style={[gs.setMarginTop(20)]}>
                 <SystemError size={36} />
               </View>
               <View style={{marginTop:16}}>
                    <Typography 
                        typeDLS={TypographyTypeDLS.H4S}
                        color={ColorTokens.Grey_Night}
                        textAlign={TextAlignTokens.center}
                        label={"Verification failed!"}
                    />
                </View>
               <View
                 style={[
                   gs.setMarginTop(16),
                   gs.setColor('#667085'),
                   gs.setMarginBottom(24),
                 ]}>
                  <Typography 
                      typeDLS={TypographyTypeDLS.B1R}
                      color={ isDarkMode? ColorTokens.White :  ColorTokens.Grey_Charcoal}
                      textAlign={TextAlignTokens.center}
                      label={showResendError?.message}
                  />
                </View>
               <Button
                 eventName={'_EDIT'}
                 label={'Edit details'}
                 type={'SOLID'}
                 handlePress={closeBottomSheet}
               />
             </View>
            ) : (
              <VerifyEmailOTP
                otpDigitCount={6}
                email={email}
                onClose={closeBottomSheet}
                onEmailUpdateSuccess={onEmailUpdateSuccess}
                userDetails={userDetails}
                onResendFail={showErrorSheetForResend}
              />
            )}
       
      </BottomSheetContainer>
      </ThemedView>
      </KeyboardDismissView>
    </ScreenWrapper>
  );
};

export default EnterEmail;
